import './../css/calculator.css';
import './../css/items-list.css';
import './../css/forms.css';
import './../css/radio.css';
import './../css/checkbox.css';
import './../css/sidebar.css';
import './../css/searchbar.css';
import './../css/messages.css';
import './../css/search-history.css';
import './../css/canon.css';